import { Component } from '@theme/component';
import { globalTimer } from '@theme/globalTimer';

class CountdownTimer extends Component {
    static observedAttributes = ["enddate"];
    requiredRefs = ['days','hours','minutes','seconds'];
    #enddateStr=null
    #enddate=null
    #days=null;
 	#hours = null;
    #minutes=null;
    #seconds=null;
    #label=null;
    constructor() {
        super();
    }

    #init= () =>{
   
        const pad = (num) => num.toString().padStart(2, '0');
        const match = this.#extractDate()
        if (!match) {
            this.#showMessage('Please enter a valid format: m/d/y', true);
            return;
        }
        const month = parseInt(match[1]);
        const day = parseInt(match[2]);
        const year = parseInt(match[3]);
        if (month < 1 || month > 12 || day < 1 || day > 31) {
            this.#showMessage('Please enter a valid month (1-12) and day (1-31).', true);
            return;
        }
        this.#enddate=new Date(`${year}-${pad(month)}-${pad(day)}T00:00:00`);
        if (isNaN(this.#enddate.getTime())) {
            this.#showMessage('Invalid date.', true);
            return;
        }
        if (this.#enddate.getTime() <= new Date().getTime()) {
            this.#showMessage('This date has already passed.', true);
            return;
        }
        // Start the global timer. Only does something if not already started.
        globalTimer.start();
        this.#update(new Date());
          // Listen for the global timer's ticks
        globalTimer.addEventListener('tick', (e) => {
            this.#update(e.detail.timestamp);
        });
        this.#updateLabel();
        this.classList.add("timer-active");
    }
    #update= (timestamp) =>{
        const pad = (num) => num.toString().padStart(2, '0');
        const now = timestamp || new Date().getTime();
        const distance = this.#enddate.getTime() - now;

        if (distance < 0) {
            clearInterval(countdownInterval);
            this.#days.element.textContent = "00";
            this.#hours.element.textContent = "00";
            this.#minutes.element.textContent = "00";
            this.#seconds.element.textContent = "00";
            showMessage('The date has passed!');
            return;
        }

        // Time calculations
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        this.#days.element.textContent = pad(days);
        this.#hours.element.textContent = pad(hours);
        this.#minutes.element.textContent = pad(minutes);
        this.#seconds.element.textContent = pad(seconds);
      
    }
    #extractDate= () =>{
        const regex = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
        return this.#enddateStr.match(regex);
    }
    #showMessage= (msg, isError = false) => {
        return;
        if (!isError){
            console.log(msg);
        }else{
            console.log(msg);
        }
    }
    #updateLabel=()=>{
        if(this.#label==null) return;
       this.#label.textContent =this.#label.textContent.replace("[date]",this.#enddate.toLocaleDateString()) ;
    }
    connectedCallback() {
        super.connectedCallback();
        this.#enddateStr=this.getAttribute("enddate");
        this.#days = {element:this.refs.days||this.querySelector('[ref="days"]')};
        this.#hours = {element:this.refs.hours||this.querySelector('[ref="hours"]')};
        this.#minutes = {element:this.refs.minutes||this.querySelector('[ref="minutes"]')};
        this.#seconds = {element:this.refs.seconds||this.querySelector('[ref="seconds"]')};
        this.#label = this.refs.label||this.querySelector('[ref="label"]')|| null ;
        this.#init();
    }

    disconnectedCallback() {
    // Disconnect all the event listeners
 
    }
    attributeChangedCallback(name, oldValue, newValue) {
       if(this.#enddateStr!=null) this.#init();
    }

}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}